import { Injectable } from "@angular/core";

@Injectable()
export class PrintProvider {
	constructor() {}
}



// WEBPACK FOOTER //
// ./src/providers/print/print.ts